import { defineMessages } from 'react-intl';

export const scope = 'app.components.vouchers.voucher_table';

export default defineMessages({
  voucher_code: {
    id: `${scope}.voucher_code`,
    defaultMessage: 'Voucher Code',
  },
  discount: {
    id: `${scope}.discount`,
    defaultMessage: 'Discount',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  sku: {
    id: `${scope}.sku`,
    defaultMessage: 'SKU',
  },
  tags: {
    id: `${scope}.tags`,
    defaultMessage: 'Tags',
  },
  max_use: {
    id: `${scope}.max_use`,
    defaultMessage: 'Max Use',
  },
  expires_on: {
    id: `${scope}.expires_on`,
    defaultMessage: 'Expires On',
  },
  created_by: {
    id: `${scope}.created_by`,
    defaultMessage: 'Created by',
  },
  redeemed_by: {
    id: `${scope}.redeemed_by`,
    defaultMessage: 'Redeemed by',
  },
});
